import React, { MouseEventHandler, ButtonHTMLAttributes } from "react";
export type BadgeType = {
    variant: `white` | `blue` | `green` | `yellow` | `red` | `gray` | `contrast`;
    squareCorners?: boolean;
    size?: `default` | `large`;
    className?: string;
    onClick?: MouseEventHandler<HTMLButtonElement> | undefined;
} & ButtonHTMLAttributes<HTMLButtonElement>;

const Badge = ({ onClick, variant, squareCorners = false, size = `default`, className = ``, ...rest }: BadgeType) => {
    const defaultBadgeClass = `Badge text-caption tracking-caption font-bold py-1 px-2 rounded-3xl border`;
    const variantClassMap = {
        white: `Badge--white text-text-primary bg-background-surface border-border-light`,
        blue: `Badge--blue text-text-primary border-info-primary bg-info-light`,
        green: `Badge--green text-success-contrast border-success-primary bg-success-light`,
        yellow: `Badge--yellow text-warning-medium border-none bg-warning-light`,
        red: `Badge--red text-text-contrast border-error-primary bg-error-primary`,
        gray: `Badge--gray text-text-primary border-info-light bg-info-light`,
        contrast: `Badge--contrast text-text-contrast border-text-contrast bg-transparent`
    };

    const sizeClassMap = {
        default: ``,
        large: `Badge--lg px-3 py-4`
    };

    const cornerClass = squareCorners ? `Badge--square rounded-md` : ``;

    if (!onClick) {
        return (
            <span className={`${defaultBadgeClass} ${variantClassMap[variant]} ${sizeClassMap[size]} ${cornerClass} ${className}`} {...rest}>
                {rest.children}
            </span>
        );
    }

    return (
        <button onClick={onClick} className={`${defaultBadgeClass} ${variantClassMap[variant]} ${sizeClassMap[size]} ${cornerClass} ${className}`} {...rest}>
            {rest.children}
        </button>
    );
};

export default Badge;
